import { useDispatch, useSelector } from 'react-redux';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Field, LinkField, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  StSiteMasterBreadcrumb,
  StSiteMasterBreadcrumbCurrent,
  StSiteMasterBreadcrumbLink,
  StSiteMasterBreadcrumbText,
} from 'components/SiteMaster/SiteMaster.styles';
import { getFieldValue } from 'components/SiteMaster/utils';
import { showLoader } from 'src/features/loaderSlice';
import { markSiteBreadcrumbReturn, resetSearch } from 'src/features/locationSearchSlice';
import { RootState } from 'src/store/store';

type SiteBreadcrumbProps = {
  label?: Field<string>;
  url?: LinkField;
  siteName?: Field<string>;
};

const SiteBreadcrumb = ({ label, url, siteName }: SiteBreadcrumbProps): JSX.Element | null => {
  const dispatch = useDispatch();
  const locality = useSelector((state: RootState) => state.locationSearch?.locationLabel ?? '');

  const searchHref = url?.value?.href ?? '';
  const hasSearchLink = Boolean(searchHref) && Boolean(getFieldValue(label));
  const siteNameValue = getFieldValue(siteName);
  const startNavigation = () => {
    dispatch(markSiteBreadcrumbReturn());
    dispatch(showLoader());
  };
  // Plain "Find a Site" has no location context; clear stale distance sort before leave.
  const startFreshSearch = () => {
    dispatch(resetSearch());
    dispatch(showLoader());
  };

  if (!locality && !siteNameValue) {
    return null;
  }

  return (
    <StSiteMasterBreadcrumb
      aria-label="Breadcrumb"
      separator={<ChevronRightIcon aria-hidden />}
      id="site-breadcrumb"
    >
      {hasSearchLink ? (
        <StSiteMasterBreadcrumbLink href={searchHref} onClick={startFreshSearch}>
          <Text field={label} />
        </StSiteMasterBreadcrumbLink>
      ) : null}

      {locality ? (
        hasSearchLink ? (
          <StSiteMasterBreadcrumbLink href={searchHref} onClick={startNavigation}>
            {locality}
          </StSiteMasterBreadcrumbLink>
        ) : (
          <StSiteMasterBreadcrumbText>{locality}</StSiteMasterBreadcrumbText>
        )
      ) : null}

      {siteNameValue ? (
        <StSiteMasterBreadcrumbCurrent aria-current="page">
          <Text field={siteName} />
        </StSiteMasterBreadcrumbCurrent>
      ) : null}
    </StSiteMasterBreadcrumb>
  );
};

export default SiteBreadcrumb;
